import React from "react"
import avatar from "avatar/maya.svg"

const Maya = (props) => <img src={avatar} className="avatar" {...props} />

export default Maya
